"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[9048],{

/***/ 79048:
/***/ ((module) => {

module.exports = JSON.parse('{"selectableStates":{"NST":"Not started","IPG":"In progress","DON":"Done"},"selectableTypes":{"NOT":"Note","BES":"Visit","EPO":"E-mail","TEL":"Phone","OVR":"Other"}}');

/***/ })

}]);